import { createContext } from 'react';

const OverdueCountContext = createContext();

export default OverdueCountContext;
